import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

Vue.config.productionTip = false;


import './assets/less/main.less'

//UI框架
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
Vue.use(Antd);

import 'element-ui/lib/theme-chalk/index.css';
import { Image,Loading } from 'element-ui';
Vue.use(Image);
Vue.use(Loading)

//http
import http from '@/https';
Vue.prototype.$https = http;

//utils
import utils from '@/utils/utils'
Vue.prototype.$utils = utils;

//监听登录状态

//注册全局组件
import pagination  from "@/views/usedComponent/pagination.vue";
import complaint from '@/views/usedComponent/complaint';
import videoList from '@/views/usedComponent/videoList'
Vue.component('complaint',complaint)
Vue.component('pagination',pagination)
Vue.component('videoList',videoList)
new Vue({
  router,
  store,
  render: (h) => h(App),
  components:{
    App
  }
}).$mount("#app");
